// removed by extract-text-webpack-plugin
module.exports = {"tabs":"_2eGIViMBhoE9XDfDffP17i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tabs/TabsWrapper/TabsWrapper.scss
// module id = 1336
// module chunks = 1